/**
 * @功能名称:
 * @文件名称: index.js
 * @Date: 2018/7/30 18:52.
 * @Author: yanqiuru
 * @Copyright（C）: 2018 X-Financial Inc.   All rights reserved.
 * 注意：本内容仅限于小赢科技有限责任公司内部传阅，禁止外泄以及用于其他的商业目的。
 */
import report from '../../../component/common/report';
require('../../../component/classBase');
require('../../../common/base.css');
require('../index/widget/widget.less')
require('./css.less');
let tpl = require('./index.tpl.html');
// let tpl = require('./html.html');
tpl = $(tpl);
$('#container').html(tpl);
let header = require('../index/widget/header.tpl.html');
$('.header').html(header);
let footer = require('../index/widget/footer.tpl.html');
$('.footer-place').html(footer);

$('.a2').siblings().removeClass('nav-on');
$('.a2').addClass('nav-on');
$('.a2').click(() => {
  $('.a2').attr("href", "#");
})
report.init({softid:5});



// WEBPACK FOOTER //
// ./src/module/landPageEN/productInfo/index.js